import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import VisibilityGroup from "../../../../groups/VisibilityGroup";

class MetricMissedImprNotaxBing extends MetricBase {
    constructor() {
        super({
            field: "metric_missed_impr_notax",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.bing-hotel-ads.missedImprNotax.chartName"),
            serieLabel: i18n.t("metrics.bing-hotel-ads.missedImprNotax.serieLabel"),
            tooltip: i18n.t("metrics.bing-hotel-ads.missedImprNotax.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricMissedImprNotaxBing;
